import { NumericPositive1Icon } from './NumericPositive1Icon';

/**
 * author: Michael Irigoyen
 * id 73DE8F6E-A301-42D1-B2C3-3699265BA2BB
 * name numeric-positive-1
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-positive-1.svg
 * tags
 * - Alpha / Numeric 
 */
export const IncrementIcon = NumericPositive1Icon;
export default IncrementIcon